import { createSelector } from 'reselect';

const selectPages = (state: AppState) => state.appData.pages;

const animatedTypes = [
  'animated_gif',
  'animation_image',
  'animation_video',
  'rendercloud_animation',
];

export const hasAnimatedLinks = createSelector(
  [selectPages],
  (pages) =>
    pages?.some((page) => page.links?.some((link) => animatedTypes.includes(link.displayType))) ||
    false,
);
